import './About.css'

export default function About() {
    return (
        <section id='about' className='container about'>
            <div className='about-grid' data-reveal>
                <div>
                    <p className='kicker'>§ 01 — About</p>
                    <h2 className='section-title'>Hi! This is my portfolio.</h2>
                </div>
                <div className='about-text'>
                    <p>
                        <span className='about-dropcap'>I</span>'m an Argentinian full-stack developer with an orientation for front-end, driven by a passion for learning and problem-solving.
                    </p>
                    <p>
                        I work with other teams, or on my own as a freelancer, to transform ideas into responsive interfaces that feel considered at every screen size. Let's work together!
                    </p>
                </div>
            </div>
        </section>
    )
}
